import React from 'react';

function Docs() {
  return (
    <div className="docs-container">
      <h1>Documentation</h1>
      <div className="card" style={{ marginTop: '1.5rem' }}>
        <h3>How to Play</h3>
        <p>1. Hold a Binance Agent ID</p>
        <p>2. Mint Gen0 ships</p>
        <p>3. Stake miners to earn $ORE; claim Safe (30% pirate tax) or Risky (15% tax, 10% chance pirates intercept). Fuel = 10% of each ship's cargo (min 100 ORE) and 1 durability per claim.</p>
        <p>3b. Stake pirates to collect the tax and intercepted cargo.</p>
        <p>4. Build Gen1 ships from 1 hour after the ORE pool opens: priced in USD ($5 for ships 1–4,000, $6.5 for 4,001–8,000, $8 for 8,001–10,000), paid in $ORE at the 30-minute ORE/BNB TWAP × Chainlink BNB/USD (lower of TWAP and spot), and 100% of it is burned. You can also upgrade miners (10k × level) or repair them (300 ORE/point).</p>
        <p>5. Trade ships on the marketplace (5% fee).</p>
        <p>AI agents: mint instructions at <a href="/llms.txt">/llms.txt</a> (same as the 🤖 panel on the Mint page).</p>
      </div>
      <div className="card" style={{ marginTop: '1rem' }}>
        <h3>Tokenomics</h3>
        <p>Total Supply: 1,000,000,000 $ORE (fixed supply, no new tokens can ever be created)</p>
        <p>Team: 5% (50M) — 30-day cliff, linear over 12 months</p>
        <p>Emissions: 85% locked reserve (850M) — 7-day seasons, 36M/day in season 1, each season 30% lower than the last (season 1 starts when the pool launches at sell-out or mint end, not during the mint; 52 seasons, ≈840M total ≈ 98.8% of the reserve; the ≈10M remainder is burned after season 52)</p>
        <p>Liquidity: 10% (100M) paired with Gen0 BNB on PancakeSwap, LP burned</p>
        <p>Gen0 mint: 60% LP / 40% → 75% Development &amp; Marketing Fund, 25% Buyback Treasury (after launch 100% → 75/25)</p>
        <p>Marketplace fee 5%: 3% Development &amp; Marketing Fund, 2% Buyback Treasury.</p>
        <p>Buybacks are executed by the Buyback Treasury and burned on-chain.</p>
      </div>
    </div>
  );
}

export default Docs;
